import { cn } from '@/utils/utils.ts';
import { getUptimeStatusConfig } from '@/components/uptime/uptime-status-config.ts';

export const BessCircleStatus = ({ status }: { status: -1 | 0 | 1 | number }) => {
  const statusDisplayConfig = getUptimeStatusConfig(status);

  return (
    <div className={cn('size-4 rounded-full', statusDisplayConfig.backgroundColor)}></div>
  );
};

export default BessCircleStatus;
